import type { ProjectAssignFormProps } from "./project-assign-form.type";

import { ModelAssignForm } from "@/modules/model-assign";

import { useProjectAssignForm } from "./project-assign-form.hook";

export const ProjectAssignForm = ({
  project,
  options,
}: ProjectAssignFormProps) => {
  const { onFormSubmit, status, error } = useProjectAssignForm({
    project,
    options,
  });

  return (
    <ModelAssignForm
      existingUsers={project.users}
      onSubmit={onFormSubmit}
      status={status}
      error={error}
    />
  );
};
